import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  getFlavour,
  getParticularPage,
  getNext,
  getPrevious,
  createFlavour,
  updateFlavour,
  handleSearch,
} from "./thunk";

const initialState = {
  flavours: [],
  edit: false,
  flavour: null,
  count: null,
  pageNo: 1,
  next: null,
  previous: null,
  loading: false,
  loadingUpdated: false,
  loadingFlavour: false,
  loadingNext: false,
  showCreateModal: false,
  // Form persistence state
  formData: {
    name: "",
    isActive: true,
  },
  activeFlavourId: null,
};

export const flavourSlice = createSlice({
  name: "flavour",
  initialState,
  reducers: {
    setShowCreateModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },
    flavourEditSuccess: (state, action) => {
      state.edit = true;
      state.flavour = state.flavours.find((flavour) => flavour.id === action.payload);
      state.formData = state.flavours.find((flavour) => flavour.id === action.payload);
      state.activeFlavourId = action.payload;
    },
    resetFlavourForm: (state, action) => {
      if (action.payload) {
        // if edit is true, reset to flavour data
        state.formData = state.flavour;
      } else {
        state.formData = initialState.formData; // if edit is false, reset to initial state
        state.activeFlavourId = null;
      }
    },
    saveFlavourForm: (state, action) => {
      state.formData = action.payload;
    },
    clearAllFlavour: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingFlavour = false;
      state.flavour = null;
      state.formData = initialState.formData;
      state.activeFlavourId = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createFlavour.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createFlavour.fulfilled, (state, action) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(createFlavour.rejected, (state) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(updateFlavour.pending, (state) => {
      state.loadingUpdated = true;
    });
    builder.addCase(updateFlavour.fulfilled, (state, action) => {
      state.loadingUpdated = false;
      state.edit = false;
    });
    builder.addCase(updateFlavour.rejected, (state) => {
      state.loadingUpdated = false;
    });
    builder.addMatcher(
      isAnyOf(
        getFlavour.pending,
        getParticularPage.pending,
        getPrevious.pending,
        getNext.pending,
        handleSearch.pending
      ),
      (state) => {
        state.loadingFlavour = true;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getFlavour.fulfilled,
        getParticularPage.fulfilled,
        getPrevious.fulfilled,
        getNext.fulfilled,
        handleSearch.fulfilled
      ),
      (state, action) => {
        state.loadingFlavour = false;
        state.flavours = action.payload.data;
        state.count = action.payload.totalCount;

        state.previous = action.payload.previous;
        state.next = action.payload.next;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getFlavour.rejected,
        getParticularPage.rejected,
        getPrevious.rejected,
        getNext.rejected,
        handleSearch.rejected
      ),
      (state) => {
        state.loadingFlavour = false;
      }
    );
  },
});

export const { setShowCreateModal, goToPage, flavourEditSuccess, saveFlavourForm, resetFlavourForm, clearAllFlavour } =
  flavourSlice.actions;

export default flavourSlice.reducer;
